module.exports = __webpack_public_path__ + "static/media/rewards.457502ba.png";